import { useState, useEffect } from 'react';
import { Badge } from '@/components/ui/badge';
import { Server, Wifi, WifiOff, Globe, ChevronRight } from 'lucide-react';

const API_BASE = '';

export default function ProvidersPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    fetch(`${API_BASE}/api/admin/providers`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-slate-500 text-center py-12">Loading...</div>;

  return (
    <div data-testid="providers-page">
      <div className="mb-6">
        <h1 className="text-2xl font-bold tracking-tight uppercase text-slate-50" style={{ fontFamily: 'var(--font-heading)' }}>
          <Server className="w-5 h-5 inline mr-2 text-indigo-400" />
          Data Providers
        </h1>
        <p className="text-sm text-slate-500 mt-1">Manage data source integrations</p>
      </div>

      <div className="space-y-4">
        {data?.providers?.map(p => (
          <div key={p.id} className={`rounded-xl border p-5 ${p.status === 'active' ? 'border-emerald-500/20 bg-emerald-500/5' : 'border-slate-800 bg-slate-900/50'}`}
            data-testid={`provider-${p.id}`}>
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className={`p-2.5 rounded-lg ${p.status === 'active' ? 'bg-emerald-500/10' : 'bg-slate-800'}`}>
                  {p.status === 'active' ? <Wifi className="w-5 h-5 text-emerald-400" /> : <WifiOff className="w-5 h-5 text-slate-500" />}
                </div>
                <div>
                  <h2 className="text-lg font-bold text-slate-100">{p.name}</h2>
                  <p className="text-xs text-slate-500">{p.description}</p>
                </div>
              </div>
              <Badge className={
                p.status === 'active' ? 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' :
                p.status === 'planned' ? 'bg-amber-500/10 text-amber-400 border-amber-500/20' :
                'bg-red-500/10 text-red-400 border-red-500/20'
              }>
                {p.status}
              </Badge>
            </div>

            <div className="flex items-center gap-4 text-xs text-slate-400">
              <span><Globe className="w-3 h-3 inline mr-1" />{p.sport}</span>
              <span>{p.leagues_configured} leagues configured</span>
            </div>

            {/* Basketball provider details */}
            {p.supported_leagues && (
              <div className="mt-4 p-3 bg-slate-800/50 rounded-lg border border-slate-700/50">
                <p className="text-xs text-slate-400 font-medium mb-2">Supported Leagues</p>
                <div className="flex flex-wrap gap-1.5">
                  {p.supported_leagues.map((lg, i) => (
                    <Badge key={i} variant="outline" className="text-xs border-slate-600 text-slate-400">
                      {lg.name} ({lg.country})
                    </Badge>
                  ))}
                </div>
                {p.supported_markets && (
                  <>
                    <p className="text-xs text-slate-400 font-medium mt-3 mb-2">Supported Markets</p>
                    <div className="flex flex-wrap gap-1.5">
                      {p.supported_markets.map((m, i) => (
                        <Badge key={i} variant="outline" className="text-xs border-slate-600 text-slate-400">
                          {m.name}
                        </Badge>
                      ))}
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
